<template>
  <HeaderTitle single back-target="settings">
    <template #bottom>{{
      t("profile.screen.about.section.imprint.tile")
    }}</template>
  </HeaderTitle>
  <BasicWrapper white>
    <div>
      <legal-text v-if="!isLoading" :text="clientStore.getLegal"></legal-text>
    </div>
  </BasicWrapper>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import BasicWrapper from "../../components/v2/layout/pageWrapper/BasicWrapper.vue";
import LegalText from "../../components/v2/legal/legalText.vue";
import { useClientStore } from "../../store/v2/client";
import HeaderTitle from "../../components/v2/layout/header/HeaderTitle.vue";

const { t } = useI18n();
const clientStore = useClientStore();
const isLoading = ref(true);
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  try {
    await clientStore.getClient(null, route.params.slug as string);
    isLoading.value = false;
  } catch (err) {
    if (typeof (window as any).$userAuthenticator?.logout === "function") {
      (window as any).$userAuthenticator.logout();
    }
    router.push({ name: "maintenancePage" });
  }
});
</script>
